/* eslint-disable global-require */

import { ssrWindow as window } from "ssr-window";

export const META_DEFAULTS = {
  custom: [],
  description: "",
  image: `${window.location.origin}${require("../images/logo.svg")}`,
  title: "Mamaginekolog",
  type: "website",
  url: window.location.origin,
};
